import { createFileRoute } from "@tanstack/react-router"
import { AssetLibraryRoutePage } from "./-AssetLibraryPage"

export const Route = createFileRoute("/asset-library")({
  component: AssetLibraryRoutePage,
})
